// This object contains endpoints that should not trigger loading indicators
export const BACKGROUND_OPERATION_ENDPOINTS_LOWERCASE: Record<
  string,
  { skipLoadingIndicators: Set<string> }
> = {
  // *** all values must be lowercase ***
  '/tallyclerk': {
    skipLoadingIndicators: new Set<string>([
      '/planning/api/orders',
      '/planning/api/orders/allowpassage',
      '/operations/api/equipments/assigntojobbytallyman',
      '/operations/api/workinstructions',
    ]),
  },
}

export const ENDPOINTS_EXCLUDED_FROM_LOADING_LOWERCASE = new Set<string>([
  // *** all values must be lowercase ***
  '/yard/api/roadnodes',
  '/yard/api/roadsegments',
])
